import React, { useState } from 'react';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';



const ModifyPopup = ({ data, onSave, onCancel, isCallOfStocks }) => {
    const [modifiedData, setModifiedData] = useState({ ...data });

    const handleInputChange = (field, value) => {
        setModifiedData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    return (
        <div className="modify-popup">
            <div className="modify-popup-content">
                <h3><LanguageStringResolver string='listingLines_ModifyEntry' /></h3>
                {isCallOfStocks ? (
                    // Call of Stocks fields
                    <>
                        <div className="form-group">
                            <LanguageStringResolver string='listingLines_coSvatNumberPrompt' />
                            <input
                                type="text"
                                value={modifiedData.coSvatNumber}
                                onChange={(e) => handleInputChange('coSvatNumber', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <LanguageStringResolver string='listingLines_coSnamePrompt' />
                            <input
                                type="text"
                                value={modifiedData.coSname}
                                onChange={(e) => handleInputChange('coSname', e.target.value)}
                            />
                        </div>

                        <div className="form-group">
                            <LanguageStringResolver string='listingLines_coSDatePrompt' />
                            <input
                                type="date"
                                value={modifiedData.coSDate}
                                onChange={(e) => handleInputChange('coSDate', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <LanguageStringResolver string='listingLines_coSamountPrompt' />
                            <input
                                type="number"
                                value={modifiedData.coSamount}
                                onChange={(e) => handleInputChange('coSamount', e.target.value)}
                            />
                        </div>

                        <div className="form-group">
                            <LanguageStringResolver string='listingLines_coSOriginalBuyerVRNPrompt' />
                            <input
                                type="text"
                                value={modifiedData.coSOriginalBuyerVRN}
                                onChange={(e) => handleInputChange('coSOriginalBuyerVRN', e.target.value)}
                            />
                        </div>

                        <div className="form-group">
                            <LanguageStringResolver string='listingLines_coSOriginalBuyerNamePrompt' />
                            <input
                                type="text"
                                value={modifiedData.coSOriginalBuyerName}
                                onChange={(e) => handleInputChange('coSOriginalBuyerName', e.target.value)}
                            />
                        </div>
                    </>
                ) : (
                    // Sales fields
                    <>
                        <div className="form-group">
                            <LanguageStringResolver string='listingLines_VATNumberSupplierPrompt' />
                            <input
                                type="text"
                                value={modifiedData.VATNumberSupplier}
                                onChange={(e) => handleInputChange('VATNumberSupplier', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <LanguageStringResolver string='listingLines_ValuePrompt' />
                            <input
                                type="number"
                                value={modifiedData.Value}
                                onChange={(e) => handleInputChange('Value', e.target.value)}
                            />
                        </div>
                    </>
                )}
                <div className="button-group">
                    <button className="primary" onClick={() => onSave(modifiedData)}>
                        <LanguageStringResolver string='common_Save' />
                    </button>
                    <button className="secondary" onClick={onCancel}>
                        <LanguageStringResolver string='common_Cancel' />
                    </button>
                </div>
            </div>
        </div>
    );
};


export default ModifyPopup;




